/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PatientRelatedPersonsPatientRelatedPerson model module.
 * @module model/PatientRelatedPersonsPatientRelatedPerson
 * @version v0.3
 */
export default class PatientRelatedPersonsPatientRelatedPerson {
  /**
   * Constructs a new <code>PatientRelatedPersonsPatientRelatedPerson</code>.
   * @alias module:model/PatientRelatedPersonsPatientRelatedPerson
   * @class
   * @param relationshipType {module:model/PatientRelatedPersonsPatientRelatedPerson.RelationshipTypeEnum} The nature of the relationship between the Patient and the related person. Currently, only a Practitioner can be related to a Patient through this endpoint.
   * @param patientId {String} The ID of the Patient in the relationship
   * @param relatedPersonId {String} The ID of the person to whom the Patient is related (currently limited to Practitioners only)
   */
  constructor(relationshipType, patientId, relatedPersonId) {
    this.relationshipType = relationshipType;
    this.patientId = patientId;
    this.relatedPersonId = relatedPersonId;
  }

  /**
   * Constructs a <code>PatientRelatedPersonsPatientRelatedPerson</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientRelatedPersonsPatientRelatedPerson} obj Optional instance to populate.
   * @return {module:model/PatientRelatedPersonsPatientRelatedPerson} The populated <code>PatientRelatedPersonsPatientRelatedPerson</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientRelatedPersonsPatientRelatedPerson();
      if (data.hasOwnProperty('relationship_type'))
        obj.relationshipType = ApiClient.convertToType(data['relationship_type'], 'String');
      if (data.hasOwnProperty('patient_id'))
        obj.patientId = ApiClient.convertToType(data['patient_id'], 'String');
      if (data.hasOwnProperty('related_person_id'))
        obj.relatedPersonId = ApiClient.convertToType(data['related_person_id'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>relationshipType</code> property.
 * @enum {String}
 * @readonly
 */
PatientRelatedPersonsPatientRelatedPerson.RelationshipTypeEnum = {
  /**
   * value: "Emergency Contact"
   * @const
   */
  emergencyContact: "Emergency Contact",

  /**
   * value: "Employer"
   * @const
   */
  employer: "Employer",

  /**
   * value: "Federal Agency"
   * @const
   */
  federalAgency: "Federal Agency",

  /**
   * value: "Insurance Company"
   * @const
   */
  insuranceCompany: "Insurance Company",

  /**
   * value: "Next-of-Kin"
   * @const
   */
  nextOfKin: "Next-of-Kin",

  /**
   * value: "Other"
   * @const
   */
  other: "Other",

  /**
   * value: "State Agency"
   * @const
   */
  stateAgency: "State Agency",

  /**
   * value: "Unknown"
   * @const
   */
  unknown: "Unknown",

  /**
   * value: "family member"
   * @const
   */
  familyMember: "family member",

  /**
   * value: "child"
   * @const
   */
  child: "child",

  /**
   * value: "adopted child"
   * @const
   */
  adoptedChild: "adopted child",

  /**
   * value: "adopted daughter"
   * @const
   */
  adoptedDaughter: "adopted daughter",

  /**
   * value: "adopted son"
   * @const
   */
  adoptedSon: "adopted son",

  /**
   * value: "foster child"
   * @const
   */
  fosterChild: "foster child",

  /**
   * value: "foster daughter"
   * @const
   */
  fosterDaughter: "foster daughter",

  /**
   * value: "foster son"
   * @const
   */
  fosterSon: "foster son",

  /**
   * value: "daughter"
   * @const
   */
  daughter: "daughter",

  /**
   * value: "natural daughter"
   * @const
   */
  naturalDaughter: "natural daughter",

  /**
   * value: "stepdaughter"
   * @const
   */
  stepdaughter: "stepdaughter",

  /**
   * value: "natural child"
   * @const
   */
  naturalChild: "natural child",

  /**
   * value: "natural son"
   * @const
   */
  naturalSon: "natural son",

  /**
   * value: "son"
   * @const
   */
  son: "son",

  /**
   * value: "stepson"
   * @const
   */
  stepson: "stepson",

  /**
   * value: "step child"
   * @const
   */
  stepChild: "step child",

  /**
   * value: "extended family member"
   * @const
   */
  extendedFamilyMember: "extended family member",

  /**
   * value: "aunt"
   * @const
   */
  aunt: "aunt",

  /**
   * value: "maternal aunt"
   * @const
   */
  maternalAunt: "maternal aunt",

  /**
   * value: "paternal aunt"
   * @const
   */
  paternalAunt: "paternal aunt",

  /**
   * value: "cousin"
   * @const
   */
  cousin: "cousin",

  /**
   * value: "maternal cousin"
   * @const
   */
  maternalCousin: "maternal cousin",

  /**
   * value: "paternal cousin"
   * @const
   */
  paternalCousin: "paternal cousin",

  /**
   * value: "great grandparent"
   * @const
   */
  greatGrandparent: "great grandparent",

  /**
   * value: "great grandfather"
   * @const
   */
  greatGrandfather: "great grandfather",

  /**
   * value: "maternal great-grandfather"
   * @const
   */
  maternalGreatGrandfather: "maternal great-grandfather",

  /**
   * value: "paternal great-grandfather"
   * @const
   */
  paternalGreatGrandfather: "paternal great-grandfather",

  /**
   * value: "great grandmother"
   * @const
   */
  greatGrandmother: "great grandmother",

  /**
   * value: "maternal great-grandmother"
   * @const
   */
  maternalGreatGrandmother: "maternal great-grandmother",

  /**
   * value: "paternal great-grandmother"
   * @const
   */
  paternalGreatGrandmother: "paternal great-grandmother",

  /**
   * value: "maternal great-grandparent"
   * @const
   */
  maternalGreatGrandparent: "maternal great-grandparent",

  /**
   * value: "paternal great-grandparent"
   * @const
   */
  paternalGreatGrandparent: "paternal great-grandparent",

  /**
   * value: "grandchild"
   * @const
   */
  grandchild: "grandchild",

  /**
   * value: "granddaughter"
   * @const
   */
  granddaughter: "granddaughter",

  /**
   * value: "grandson"
   * @const
   */
  grandson: "grandson",

  /**
   * value: "grandparent"
   * @const
   */
  grandparent: "grandparent",

  /**
   * value: "grandfather"
   * @const
   */
  grandfather: "grandfather",

  /**
   * value: "maternal grandfather"
   * @const
   */
  maternalGrandfather: "maternal grandfather",

  /**
   * value: "paternal grandfather"
   * @const
   */
  paternalGrandfather: "paternal grandfather",

  /**
   * value: "grandmother"
   * @const
   */
  grandmother: "grandmother",

  /**
   * value: "maternal grandmother"
   * @const
   */
  maternalGrandmother: "maternal grandmother",

  /**
   * value: "paternal grandmother"
   * @const
   */
  paternalGrandmother: "paternal grandmother",

  /**
   * value: "maternal grandparent"
   * @const
   */
  maternalGrandparent: "maternal grandparent",

  /**
   * value: "paternal grandparent"
   * @const
   */
  paternalGrandparent: "paternal grandparent",

  /**
   * value: "inlaw"
   * @const
   */
  inlaw: "inlaw",

  /**
   * value: "child-in-law"
   * @const
   */
  childInLaw: "child-in-law",

  /**
   * value: "daughter in-law"
   * @const
   */
  daughterInLaw: "daughter in-law",

  /**
   * value: "son in-law"
   * @const
   */
  sonInLaw: "son in-law",

  /**
   * value: "parent in-law"
   * @const
   */
  parentInLaw: "parent in-law",

  /**
   * value: "father-in-law"
   * @const
   */
  fatherInLaw: "father-in-law",

  /**
   * value: "mother-in-law"
   * @const
   */
  motherInLaw: "mother-in-law",

  /**
   * value: "sibling in-law"
   * @const
   */
  siblingInLaw: "sibling in-law",

  /**
   * value: "brother-in-law"
   * @const
   */
  brotherInLaw: "brother-in-law",

  /**
   * value: "sister-in-law"
   * @const
   */
  sisterInLaw: "sister-in-law",

  /**
   * value: "niece/nephew"
   * @const
   */
  niecenephew: "niece/nephew",

  /**
   * value: "nephew"
   * @const
   */
  nephew: "nephew",

  /**
   * value: "niece"
   * @const
   */
  niece: "niece",

  /**
   * value: "uncle"
   * @const
   */
  uncle: "uncle",

  /**
   * value: "maternal uncle"
   * @const
   */
  maternalUncle: "maternal uncle",

  /**
   * value: "paternal uncle"
   * @const
   */
  paternalUncle: "paternal uncle",

  /**
   * value: "parent"
   * @const
   */
  parent: "parent",

  /**
   * value: "adoptive parent"
   * @const
   */
  adoptiveParent: "adoptive parent",

  /**
   * value: "adoptive father"
   * @const
   */
  adoptiveFather: "adoptive father",

  /**
   * value: "adoptive mother"
   * @const
   */
  adoptiveMother: "adoptive mother",

  /**
   * value: "father"
   * @const
   */
  father: "father",

  /**
   * value: "foster father"
   * @const
   */
  fosterFather: "foster father",

  /**
   * value: "natural father"
   * @const
   */
  naturalFather: "natural father",

  /**
   * value: "natural father of fetus"
   * @const
   */
  naturalFatherOfFetus: "natural father of fetus",

  /**
   * value: "stepfather"
   * @const
   */
  stepfather: "stepfather",

  /**
   * value: "mother"
   * @const
   */
  mother: "mother",

  /**
   * value: "gestational mother"
   * @const
   */
  gestationalMother: "gestational mother",

  /**
   * value: "foster mother"
   * @const
   */
  fosterMother: "foster mother",

  /**
   * value: "natural mother"
   * @const
   */
  naturalMother: "natural mother",

  /**
   * value: "natural mother of fetus"
   * @const
   */
  naturalMotherOfFetus: "natural mother of fetus",

  /**
   * value: "stepmother"
   * @const
   */
  stepmother: "stepmother",

  /**
   * value: "natural parent"
   * @const
   */
  naturalParent: "natural parent",

  /**
   * value: "foster parent"
   * @const
   */
  fosterParent: "foster parent",

  /**
   * value: "step parent"
   * @const
   */
  stepParent: "step parent",

  /**
   * value: "sibling"
   * @const
   */
  sibling: "sibling",

  /**
   * value: "brother"
   * @const
   */
  brother: "brother",

  /**
   * value: "half-brother"
   * @const
   */
  halfBrother: "half-brother",

  /**
   * value: "natural brother"
   * @const
   */
  naturalBrother: "natural brother",

  /**
   * value: "twin brother"
   * @const
   */
  twinBrother: "twin brother",

  /**
   * value: "fraternal twin brother"
   * @const
   */
  fraternalTwinBrother: "fraternal twin brother",

  /**
   * value: "identical twin brother"
   * @const
   */
  identicalTwinBrother: "identical twin brother",

  /**
   * value: "stepbrother"
   * @const
   */
  stepbrother: "stepbrother",

  /**
   * value: "half-sibling"
   * @const
   */
  halfSibling: "half-sibling",

  /**
   * value: "half-sister"
   * @const
   */
  halfSister: "half-sister",

  /**
   * value: "natural sibling"
   * @const
   */
  naturalSibling: "natural sibling",

  /**
   * value: "natural sister"
   * @const
   */
  naturalSister: "natural sister",

  /**
   * value: "twin sister"
   * @const
   */
  twinSister: "twin sister",

  /**
   * value: "fraternal twin sister"
   * @const
   */
  fraternalTwinSister: "fraternal twin sister",

  /**
   * value: "identical twin sister"
   * @const
   */
  identicalTwinSister: "identical twin sister",

  /**
   * value: "twin"
   * @const
   */
  twin: "twin",

  /**
   * value: "fraternal twin"
   * @const
   */
  fraternalTwin: "fraternal twin",

  /**
   * value: "identical twin"
   * @const
   */
  identicalTwin: "identical twin",

  /**
   * value: "sister"
   * @const
   */
  sister: "sister",

  /**
   * value: "stepsister"
   * @const
   */
  stepsister: "stepsister",

  /**
   * value: "step sibling"
   * @const
   */
  stepSibling: "step sibling",

  /**
   * value: "significant other"
   * @const
   */
  significantOther: "significant other",

  /**
   * value: "domestic partner"
   * @const
   */
  domesticPartner: "domestic partner",

  /**
   * value: "former spouse"
   * @const
   */
  formerSpouse: "former spouse",

  /**
   * value: "spouse"
   * @const
   */
  spouse: "spouse",

  /**
   * value: "husband"
   * @const
   */
  husband: "husband",

  /**
   * value: "wife"
   * @const
   */
  wife: "wife",

  /**
   * value: "unrelated friend"
   * @const
   */
  unrelatedFriend: "unrelated friend",

  /**
   * value: "neighbor"
   * @const
   */
  neighbor: "neighbor",

  /**
   * value: "self"
   * @const
   */
  self: "self",

  /**
   * value: "Roommate"
   * @const
   */
  roommate: "Roommate",

  /**
   * value: "Practitioner"
   * @const
   */
  practitioner: "Practitioner"
};
/**
 * The nature of the relationship between the Patient and the related person. Currently, only a Practitioner can be related to a Patient through this endpoint.
 * @member {module:model/PatientRelatedPersonsPatientRelatedPerson.RelationshipTypeEnum} relationshipType
 */
PatientRelatedPersonsPatientRelatedPerson.prototype.relationshipType = undefined;

/**
 * The ID of the Patient in the relationship
 * @member {String} patientId
 */
PatientRelatedPersonsPatientRelatedPerson.prototype.patientId = undefined;

/**
 * The ID of the person to whom the Patient is related (currently limited to Practitioners only)
 * @member {String} relatedPersonId
 */
PatientRelatedPersonsPatientRelatedPerson.prototype.relatedPersonId = undefined;

